module.exports = __webpack_public_path__ + "assets/f1ae582215489c5331ca91abe93e14c3.png";